const initializeShare = (root) => {
  if (root.dataset.shareInitialized === 'true') return;
  root.dataset.shareInitialized = 'true';

  const url = root.dataset.shareUrl;
  const title = root.dataset.shareTitle;
  const text = root.dataset.shareText;
  const manual = root.querySelector('[data-share-manual]');
  const manualWrap = root.querySelector('[data-share-manual-wrap]');
  const status = root.querySelector('[data-share-status]');
  const copyButtons = root.querySelectorAll('[data-share-copy]');
  const nativeButton = root.querySelector('[data-share-native]');

  const manualFallback = (message) => {
    status.textContent = message;
    manualWrap.hidden = false;
    manual.focus();
    manual.select();
  };

  for (const button of copyButtons) {
    button.hidden = false;
    button.addEventListener('click', async () => {
      if (!navigator.clipboard?.writeText) {
        manualFallback(root.dataset.copyFailure);
        return;
      }
      try {
        await navigator.clipboard.writeText(url);
        status.textContent = root.dataset.copySuccess;
      } catch {
        manualFallback(root.dataset.copyFailure);
      }
    });
  }

  if (typeof navigator.share === 'function') {
    nativeButton.hidden = false;
    nativeButton.addEventListener('click', async () => {
      try {
        await navigator.share({ title, text, url });
        status.textContent = '';
      } catch (error) {
        if (error?.name !== 'AbortError') manualFallback(root.dataset.shareFailure);
      }
    });
  }
};

const initializeAllShares = () => {
  document.querySelectorAll('[data-product-share]').forEach(initializeShare);
};

initializeAllShares();
document.addEventListener('shopify:section:load', initializeAllShares);
